module.exports = __webpack_public_path__ + "static/media/text.7b80bec7.png";